var React = require('react');

function UberPickupInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","strokeLinecap":"square","strokeLinejoin":"round","stroke":"currentColor","strokeWidth":"2"},[React.createElement("rect",{"x":"5","y":"5","width":"54","height":"54","rx":"4","key":0}),React.createElement("path",{"d":"M26 32H14","key":1}),React.createElement("circle",{"cx":"32","cy":"32","r":"18","key":2}),React.createElement("rect",{"x":"26","y":"25","width":"13","height":"14","rx":"2","key":3})]));
}

UberPickupInline.defaultProps = {"viewBox":"0 0 64 64"};

module.exports = UberPickupInline;

UberPickupInline.default = UberPickupInline;
